import React from "react";
import { HeadingEnum } from "../../enums/htmlTags";

export const HeadingTag: React.FC<{
  type?: HeadingEnum;
  children?: React.ReactNode;
  className?: string;
}> = ({ type, children, className }) => {
  return React.createElement(type || HeadingEnum.h1, { className }, children);
};
